import { useState } from "react";
import { cn } from "@shared/lib/utils";

/**
 * Le logo d'une organisation : l'icône que publie son site (la plus grande
 * annoncée, souvent l'icône Apple en 180 px), servie par `/api/favicon`. Sans
 * site ou sans icône exploitable, un monogramme neutre la remplace : une
 * pastille vide ne dirait rien.
 */
export function OrgLogo({
  name,
  website,
  size = 36,
  className,
}: {
  name: string;
  website: string | null;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const initials = name
    .replace(/[—–-].*$/, "")
    .split(/\s+/)
    .filter((word) => /^[\p{L}\d]/u.test(word))
    .slice(0, 2)
    .map((word) => word[0]!.toUpperCase())
    .join("");

  return (
    <span
      aria-hidden="true"
      className={cn(
        "grid flex-none place-items-center overflow-hidden rounded-lg border bg-background font-medium text-muted-foreground",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
    >
      {website && !failed ? (
        <img
          alt=""
          className="object-contain"
          height={Math.round(size * 0.62)}
          onError={() => setFailed(true)}
          src={`/api/favicon?url=${encodeURIComponent(website)}`}
          width={Math.round(size * 0.62)}
        />
      ) : (
        initials || "?"
      )}
    </span>
  );
}
